import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vant from "vant";
import "vant/lib/index.css";
import "./axios";
// import './axios/router'
import wxConfig from "./assets/js/wxConfig.js";
import "@/assets/font/font.css";
import "wowjs/css/libs/animate.css";
import { WOW } from "wowjs";

Vue.use(wxConfig);
Vue.use(Vant);
//引入vconsole
if (process.env.NODE_ENV !== "production") {
  require("./assets/js/vconsole");
}

Vue.prototype.$wow = function(boxClass) {
  var wow = new WOW({
    boxClass: boxClass,
    animateClass: "animated",
    offset: 0,
    mobile: true,
  });
  wow.init();
};
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
